import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function AddedIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M6 12.2105L10.0345 16L19 7" stroke={props.fill} strokeWidth="2" strokeLinecap="round" />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<AddedIcon fill={props.fill} />
		</div>
	);
}